<script>
import Validation from '@/components/Validation'
import Dropdown from '@/components/UI/Dropdown'
import ParseFunctions from '@/components/ParseFunctions'

import { isMobile } from 'mobile-device-detect'

export default {
  components: {
    Dropdown,
  },
  mixins: [Validation, ParseFunctions],
  props: {
    token: String,
    email: String,
  },
  data() {
    return {
      confirmStatus: null,
      fullname: '',
      password: '',
      timezone: 'Europe/Warsaw',
      userExists: true,
      timezones: null,
    }
  },
  async created() {
    await this.tryToConfirmTeamMember()
  },
  methods: {
    async tryToConfirmTeamMember() {
      let res
      try {
        res = await this.checkInvitedUser(this.$route.query.email, this.$route.query.token)
        // console.log('checkInvitedUser res', res)
      } catch (e) {
        // console.log('checkInvitedUser err', e)
      }

      if (res.status === 'ok') {
        if (res.response === 'existingUser') {
          res = await this.confirmTeamMember(this.$route.query.email, this.$route.query.token)
          if (isMobile) {
            window.location = 'clavoapp://ConfirmTeamMember/' + this.$route.query
          }
          await this.$router.push({ path: '/login', query: { action: 'accept-invitation' } })
        } else if (res.response === 'nonexistingUser') {
          await this.$router.push({
            path: '/register',
            query: {
              action: 'simple-registration',
              token: this.$route.query.token,
              email: this.$route.query.email,
              teamId: res.teamId,
              teamName: res.teamName,
            },
            params: {
              user: res.user
            }
          })
        }
      } else {
        console.error('Received error message from checkIfUserExists: ', res)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  @include center-with-flexbox();

  .register {
    width: 400px;
    margin-top: 100px;

    h1 {
      margin-bottom: 9px;
    }

    p {
      margin-top: 10px;
      margin-bottom: 30px;
    }

    input {
      @include font-rule('averta-regular');
      display: block;
      font-size: 20px;
      color: $black;
      width: 391px;
      border: 0;
      border-bottom: 1px solid $flax-bloom;

      &:focus {
        border-color: $blue;
        outline: none;
      }

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
      }
    }

    button {
      margin-top: 60px;
      margin-bottom: 36px;
      //background-color: #B2B6E1;
      width: 240px;
      padding: 15px;
      cursor: auto;

      &.active {
        cursor: pointer;
      }
    }

    label {
      font-size: 12px;
      text-transform: uppercase;
      //margin-top: 35px;
      display: block;
      margin-top: 30px;
      margin-bottom: 5px;
    }
  }
}
</style>
